<template>
  <div class="flexbox-fullheight form-view" style="position: relative">
    <modal v-if="showModal" :type="modalType" :data="modalData" @close="closeModal" />
    <div class="map-wrapper">
        <base-map ref="baseMap" :config="mapConfig" :supplyCode="selectedSupplyType.code" :supplyTypeId="selectedSupplyType.id" :resizer="false" :vectorLayerClicked="vectorLayerClicked" @infoActive="infoButtonActive = $event" />

        <router-link class="flexbox-center floating-button" :to="{ name: 'dashboard' }">
            <span class="floating-button-label">Tilbage til oversigt</span>
            <icon class="large-svg fill-white stroke-white" name="arrow-left"></icon>
        </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { NMapConfig, NMapButton, NMapButtonGroup, NMapDraw, NMapStyle } from 'ncomponents-map'
import baseMap from '@/components/shared/map/base-map.vue'
import modal from '@/components/shared/modal/modal.vue'

export default {
    name: 'Map',
    components: {
        'base-map': baseMap,
        modal
    },
    data () {
        return {
            mapConfig: null,
            addressObject: {
                oneLineAddress: ''
            },
            showModal: false,
            highlightLayer: null,
            requisitionErrorLayer: null,
            infoButtonActive: false,
            vectorLayerClicked: false,
            addressConfig: {
                minLength: 2,
                autoSelectFirst: true,
                showResultsOnFocus: true,
                isAsync: true,

                options: {
                    per_side: 40,
                    srid: 25832,
                    type: 'adgangsadresse',
                    kommunekode: null
                }
            },
            addressList: []
        }
    },
    computed: {
        ...mapGetters({
            applicationSettings: 'getApplicationSettings',
            selectedSupplyType: 'selectedSupplyType',
            supplyTypes: 'getBusinessAreaTypes',
            userInfo: 'userInfo'
        }),
        getLayers () {
            const mapServices = this.applicationSettings.kortinfoSettings[this.selectedSupplyType.code].mapServiceList.filter((service) => {
                return (service.type === 'ogc' || service.type === 'arcgis' || service.type === 'kortinfo' || service.type === 'ogckortinfo') && service.wfsUpdateable
            })
            const layersCombined = []

            if (mapServices) {
                mapServices.forEach((service) => {
                    layersCombined.push(service.layers)
                })
            }

            return layersCombined.flat()
        },
        checkLayerEditable: function () {
            const mapServices = this.applicationSettings.kortinfoSettings[this.selectedSupplyType.code].mapServiceList.filter((service) => {
                return service.type === 'ogc' || service.type === 'arcgis' || service.type === 'kortinfo' || service.type === 'ogckortinfo'
            })

            if (mapServices && mapServices.every(service => service.layers.every(layer => layer.updateable === true))) {
                return true
            }

            return false
        }
    },
    created () {
        this.mapConfig = new NMapConfig()
        if (this.checkLayerEditable) {
            const drawColor = 'skyblue'
            const finishedColor = 'darkseagreen'

            const updateObjects = new NMapButton({
                content: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 752 752" style="margin-left: -6px; margin-top: -6px;"><path fill="white" d="m497.24 248.13c-8.9961-7.1055-22.258-5.2109-29.363 3.7891-7.1055 8.9961-5.2109 22.258 3.7891 29.363 38.359 29.836 60.145 74.352 60.145 122.66 0 85.719-70.09 155.34-155.81 155.34-85.715 0-155.81-69.617-155.81-155.34 0-81.457 63.461-148.7 143.5-154.86l-19.418 19.418c-8.0508 8.0508-8.0508 21.312 0 29.363 4.2617 4.2617 9.4727 6.1562 14.68 6.1562 5.2109 0 10.418-1.8945 14.68-6.1562l55.41-55.41c8.0508-8.0508 8.0508-21.312 0-29.363l-55.406-55.883c-8.0508-8.0508-21.312-8.0508-29.363 0s-8.0508 21.312 0 29.363l20.363 20.363c-103.24 6.1562-185.64 91.875-185.64 197.01 0 108.92 88.559 197.01 197.01 197.01s197.01-88.559 197.01-197.01c0.003907-61.562-27.465-117.92-75.77-155.81z"/><path fill="white" d="m323.43 403.94c0 15.695-12.723 28.418-28.414 28.418-15.695 0-28.414-12.723-28.414-28.418 0-15.691 12.719-28.414 28.414-28.414 15.691 0 28.414 12.723 28.414 28.414"/><path fill="white" d="m404.42 403.94c0 15.695-12.723 28.418-28.418 28.418-15.691 0-28.414-12.723-28.414-28.418 0-15.691 12.723-28.414 28.414-28.414 15.695 0 28.418 12.723 28.418 28.414"/><path fill="white" d="m485.4 403.94c0 15.695-12.723 28.418-28.414 28.418-15.695 0-28.414-12.723-28.414-28.418 0-15.691 12.719-28.414 28.414-28.414 15.691 0 28.414 12.723 28.414 28.414"/></svg>',
                title: 'Opdater objekter'
            })
            updateObjects.on('click', () => {
                this.mapConfig.cancelDraw()
                this.clearDrawLayer()

                const drawPolygon = new NMapDraw({
                    type: 'Polygon',
                    style: new NMapStyle({
                        fillColor: drawColor,
                        strokeColor: drawColor
                    }),
                    drawStyle: new NMapStyle({
                        fillColor: drawColor,
                        fillOpacity: 0.5,
                        strokeColor: drawColor
                    })
                })

                drawPolygon.on('done', (event) => {
                    event.feature.style.fillColor = finishedColor
                    event.feature.style.fillOpacity = 0.5
                    event.feature.style.strokeColor = finishedColor

                    const data = {
                        wkt: event.feature.wkt('EPSG:25832')
                    }
                    this.openModal('objects-selection-filter', data)
                    this.clearDrawLayer()
                })
                this.mapConfig.draw(drawPolygon)
            })
            this.mapConfig.addButton(updateObjects)
            this.mapConfig.on('moved', (e) => {
                this.clearDrawLayer()
            })
        }

        if (this.supplyTypes.length > 0) {
            this.setSelectedSupplyTypeFromId(this.supplyTypes[0].sysBusinessAreaTypeId)
            if (this.supplyTypes.length > 1) {
                const buttons = []
                this.supplyTypes.forEach((supplyType) => {
                    buttons.push({
                        id: supplyType.systemName,
                        content: this.getMapButtonContent(supplyType.systemName),
                        title: supplyType.description
                    })
                })
                const buttonGroup = new NMapButtonGroup({
                    direction: 'primary',
                    axis: window.innerWidth <= 768 ? 'vertical' : 'horizontal',
                    buttons: buttons
                })

                buttonGroup.on('click', (btn) => {
                    this.setSelectedSupplyTypeFromId(this.supplyTypes.find(s => s.systemName === btn.button).sysBusinessAreaTypeId)
                    this.toggleSelectedSupplyType(btn.button)
                })

                this.mapConfig.addControl(buttonGroup)
            }
        }
    },
    mounted () {
        if (this.supplyTypes.length > 1) {
            this.toggleSelectedSupplyType(this.supplyTypes[0].systemName)
        }
    },
    methods: {
        ...mapActions({
            setSelectedSupplyTypeFromId: 'setSelectedSupplyTypeFromId'
        }),
        toggleSelectedSupplyType (supplyTypeName) {
            if (document.querySelector('[id^="supply_"].selected') !== null) {
                document.querySelector('[id^="supply_"].selected').classList.remove('selected')
            }
            const element = document.getElementById('supply_' + supplyTypeName)
            element.classList.add('selected')
        },
        toggleSelectedDigitalization (buttonName) {
            const element = document.getElementById('digi_' + buttonName)
            let elementSelected = false
            if (element.classList.contains('selected')) {
                elementSelected = true
            }
            if (document.querySelector('[id^="digi_"].selected') !== null) {
                document.querySelector('[id^="digi_"].selected').classList.remove('selected')
            }
            if (!elementSelected) {
                element.classList.add('selected')
            }
        },
        openModal (type, data) {
            this.showModal = true
            this.modalType = type
            this.modalData = data
        },
        closeModal () {
            this.showModal = false
            this.clearDrawLayer()
            this.mapConfig.layerManager.getVisibleLayersAsList().filter(layer => !layer.manager.base).forEach(layer => layer.redraw())
        },
        getMapButtonContent (buttonName) {
            switch (buttonName) {
            case 'water':
                return '<svg id="supply_water" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">' +
                    '<path class="fill-white" d="M17.17,10.22c1.81,2.26,3.9,5.63,3.9,8.45A5.09,5.09,0,0,1,16.22,24H16c-.05,0-5-.13-5.07-4.85,0-1.57,1.61-3.35,3.21-5.07a20.39,20.39,0,0,0,3-3.86M15.75,6v.11c1.81,4.33-6.94,8.08-6.82,13.08C9.06,24.43,13.64,26,16,26a7.1,7.1,0,0,0,7.07-7.13v-.2C23.07,12.8,16.28,6,15.75,6Z"/>' +
                '</svg>'
            case 'sewer':
                return '<svg id="supply_sewer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">' +
                    '<path class="fill-white" d="M15.82,7.56h0a8.67,8.67,0,0,1,.7,17.3h-.7a8.65,8.65,0,1,1,0-17.3m0-1.3a10,10,0,1,0,10,10,9.92,9.92,0,0,0-3.6-7.7A10,10,0,0,0,15.82,6.26Z"/>' +
                    '<rect class="fill-white" x="15.73" y="7.67" width="0.7" height="17.3" transform="translate(-6.77 18.05) rotate(-49.76)"/>' +
                    '<rect class="fill-white" x="13.11" y="11" width="0.7" height="16.2" transform="translate(-9.82 17.12) rotate(-49.96)"/>' +
                    '<rect class="fill-white" x="18.28" y="5.34" width="0.7" height="15.5" transform="translate(-3.38 18.91) rotate(-49.89)"/>' +
                    '<path class="fill-white" d="M9.62,23.86a.37.37,0,0,1-.3-.1l-.3-.9.6.2-.4-.4c0-.1.1-.2.3-.4,4.2-6.3,8.3-10.4,12.3-12.2l.5,1.2c-2.5,1.1-6.7,4.1-11.9,11.8C10.12,23.46,9.92,23.86,9.62,23.86Zm0-.7.6.2Z"/>' +
                '</svg>'
            case 'streetlights':
                return '<svg id="supply_streetlights" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">' +
                    '<path class="fill-white" d="M16,22.67a.33.33,0,0,0-.33.33v2.67a.33.33,0,0,0,.66,0V23A.33.33,0,0,0,16,22.67Z"/>' +
                    '<path class="fill-white" d="M18.62,22.21a.33.33,0,0,0-.45-.13.34.34,0,0,0-.13.46h0l1.34,2.31a.33.33,0,0,0,.58-.33Z"/>' +
                    '<path class="fill-white" d="M22.52,21.71l-2.31-1.33a.33.33,0,0,0-.46.12.33.33,0,0,0,.12.45h0l2.31,1.33a.34.34,0,0,0,.34-.58Z"/>' +
                    '<path class="fill-white" d="M12.25,20.5h0a.34.34,0,0,0-.46-.12h0L9.48,21.71a.34.34,0,0,0-.12.46.33.33,0,0,0,.45.12h0L12.12,21A.34.34,0,0,0,12.25,20.5Z"/>' +
                    '<path class="fill-white" d="M13.83,22.09h0a.32.32,0,0,0-.45.12h0L12,24.52a.33.33,0,0,0,.58.33h0L14,22.54A.33.33,0,0,0,13.83,22.09Z"/>' +
                    '<path class="fill-white" d="M16.33,10.34v-2a2,2,0,0,0,1.67-2A.33.33,0,0,0,17.67,6H14.33a.33.33,0,0,0-.33.33,2,2,0,0,0,1.67,2v2a8,8,0,0,0-7.67,8,.34.34,0,0,0,.33.34h4a3.66,3.66,0,0,0,7.3,0h4a.34.34,0,0,0,.33-.34A8,8,0,0,0,16.33,10.34ZM14.71,6.67h2.58a1.34,1.34,0,0,1-1.62,1A1.35,1.35,0,0,1,14.71,6.67ZM16,21.33a3,3,0,0,1-3-2.66h6A3,3,0,0,1,16,21.33ZM8.67,18a7.34,7.34,0,0,1,14.66,0Z"/>' +
                    '<path class="fill-white" d="M13.54,12.5a6.34,6.34,0,0,0-2.47,1.85.34.34,0,0,0,0,.47.33.33,0,0,0,.47-.05,5.84,5.84,0,0,1,2.21-1.66.33.33,0,0,0-.26-.61Z"/>' +
                '</svg>'
            case 'greencare':
                return '<svg id="supply_greencare" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">' +
                    '<path class="fill-white" d="M23.81,6.64a.59.59,0,0,0-.5-.46,19.37,19.37,0,0,0-6.64.22,12.89,12.89,0,0,0-6.45,3.48,7,7,0,0,0,0,9.9,8.19,8.19,0,0,0,.84.72v4.91a.59.59,0,1,0,1.17,0V21.19a7,7,0,0,0,7.89-1.41c2.07-2.06,1.64-4.91,1.5-6.5-.22-2.44-.4-4.54,1.93-6A.59.59,0,0,0,23.81,6.64ZM11.05,10.71a12.28,12.28,0,0,1,8-3.49,14.16,14.16,0,0,0-3.92,2.92,14.81,14.81,0,0,0-4,8.88,5.84,5.84,0,0,1-.07-8.31Zm9.4,2.67c.18,2.09.36,4.06-1.16,5.57a5.79,5.79,0,0,1-4.12,1.71,5.85,5.85,0,0,1-2.93-.79A13.64,13.64,0,0,1,16,11a12.49,12.49,0,0,1,3.58-2.67,9.52,9.52,0,0,1,1.88-.69,5,5,0,0,0-1,2,12.79,12.79,0,0,0,0,3.76Z"/>' +
                '</svg>'
            }
        },
        clearDrawLayer () {
            let drawLayer = this.mapConfig.layers.find((layer) => {
                return layer.manager.name === 'draw'
            })
            drawLayer.clear()
        }
    }
}
</script>

<style lang="scss">
.map-wrapper {
    height: 100%;
    position: relative;
    width: 100%;

    .dmap-window {
        height: 100%;
        z-index: auto;
    }
}
.address-search {
    position: absolute;
    right: 20px;
    top: 15px;

    input {
        width: 350px;
    }
}
#supply_water,
#supply_sewer,
#supply_streetlights,
#supply_greencare {

    &.selected {
        outline: 3px solid #1d3044;
    }
}

@media only screen and (max-width: 600px) {
    .map-wrapper {
        .dmap-window {
            visibility: visible;
        }
    }
    .address-search {
        top: 10px;
        right: 10px;

        input {
            width: 300px;
        }
    }
}

@import '../scss/components/floating-button.scss';
</style>



// WEBPACK FOOTER //
// src/pages/map.vue